import moment from 'moment';

export const getDateFromNextDays = x => moment().add(x, 'd').format("YYYY-MM-DD")
